import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1Medium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconCheckmark1Medium"><Path d="M17.1904 6.41296C17.5145 5.96596 18.1397 5.8664 18.5869 6.1903C19.0339 6.51435 19.1335 7.13962 18.8096 7.58679L10.8418 18.5868C10.6724 18.8204 10.4104 18.9697 10.123 18.996C9.83563 19.0221 9.55061 18.9227 9.34179 18.7235L5.30957 14.8729C4.91015 14.4915 4.89497 13.8583 5.27636 13.4589C5.65774 13.0595 6.29099 13.0453 6.69043 13.4266L9.89355 16.4852L17.1904 6.41296Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark1Medium;
